import React, {useEffect, useState} from 'react';
import {useRouter} from "next/router";
import {CmPlaceholder} from "../../../../packages/graphql-layer/src";
import axios from "axios";
import {SERVICES} from "../../../common/constants/routes";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";

interface CmAction extends CmPlaceholder {
    actionSettings: any
}

interface Props {
    cmAction: CmAction
    csrfToken: string
}


function C077LobsterRequestSimpleAction(props: any) {
    const router = useRouter();
    const [lobsterData, setLobsterData] = useState('');
    const [error, setError] = React.useState('');
    const {t} = useTranslation();
    const actionConfiguration = props.cmAction?.actionSettings?.actionConfiguration;
    const errorMessage = actionConfiguration.errorMessage || t("lobster_request.error_message");
    const errorElement = <Typography variant="h6" color="error">{errorMessage}</Typography>;

    useEffect(() => {
        if (!mandatoryParametersPresent()) {
            setError(errorMessage);
        }
    }, []);

    useEffect(() => {
        let receivedData = false;
        let requestData: any = {
            csrfToken: props.csrfToken,
            id: props.cmAction.id,
        }
        addRequestParameters(requestData);
        retrieveData(requestData, receivedData);
        return () => {
            receivedData = true;
        }
    }, []);

    function retrieveData(requestData: any, receivedData: boolean) {
        if (!receivedData && mandatoryParametersPresent()) {
            axios({
                method: "post",
                url: SERVICES.LOBSTER_REQUEST,
                data: requestData,
            }).then(function (success) {
                setLobsterData(success.data.responseBody);
            }).catch(function (error) {
                console.log("error " + error);
                setError(errorMessage);
            });
        }
    }

    function mandatoryParametersPresent()  {
        const mandatoryCheck = (parameter:string) => router.query[parameter];
        return actionConfiguration.mandatoryRequestParameters?.split(',').every(mandatoryCheck);
    }

    function addRequestParameters(requestData: any) {
        actionConfiguration.mandatoryRequestParameters?.split(',').forEach((parameter: any) => {
            router.query[parameter] && (requestData[parameter] = encodeURI(router.query[parameter] as string));
        });
        actionConfiguration.optionalRequestParameters?.split(',').forEach((parameter: any) => {
            router.query[parameter] && (requestData[parameter] = encodeURI(router.query[parameter] as string));
        });
        Object.assign(requestData, actionConfiguration.actionParameters!);
    }

    function replacePlaceholder(): any {
        const richTextsArray: any[] = [];
        Object.values(JSON.parse(lobsterData).responseData).map((responseItem:any) => {
            let replacedText = JSON.stringify(props.cmAction.teaserText.textAsTree);
            Object.entries(responseItem).forEach(([key, value]) => {
                let keyPlaceholder = "${" + key + "}";
                replacedText = replacedText.replaceAll(keyPlaceholder, value as string);
            });
            const invalidParamsPattern = /\${(.+?)}/g;
            replacedText = replacedText.replaceAll(invalidParamsPattern, "");
            richTextsArray.push(JSON.parse(replacedText));
        });
        return richTextsArray;
    }

    return <CCOComponentWrapper>
        <CCOContainer key={props.cmAction.id}>
            <>{error && errorElement}</>
            {lobsterData &&
                replacePlaceholder().map((richText: any, index: number) => <CCORichText metadataId={props.cmAction.id} key={index} textAsTree={richText}/>)}
        </CCOContainer>
    </CCOComponentWrapper>;
}

export default C077LobsterRequestSimpleAction;